import { ExternalServiceId, RuntimeDate, Uuid } from '@edgebox/data-definition-kit';
import { EntityRemoteStatus } from '@edgebox/sync-core-data-definitions';
import { ClientRemoteEntityCloneEntity } from '@edgebox/sync-core-rest-client';
import React, { useContext, useEffect, useState } from 'react';

import { SyncCoreApiContext } from '../contexts/SyncCoreApiContext';
import { FormatDate } from './FormatDate';
import { RemoteEntityStatusBadge } from './RemoteEntityStatusBadge';
import { SiteEntityName } from './SiteEntityName';

export function RemoteEntityCloneListItem({ clone }: { clone: ClientRemoteEntityCloneEntity }): React.ReactElement {
  const api = useContext(SyncCoreApiContext)?.api;
  const [entityTypeInfo, setEntityTypeInfo] = useState<{ namespaceMachineName: ExternalServiceId; machineName: ExternalServiceId }>();

  const isDeleted = clone.status !== EntityRemoteStatus.Exists || !!clone.deletedAt;

  const entityTypeId = clone.entityType.getId();
  useEffect(() => {
    if (!api) {
      return;
    }

    let cancelled = false;

    const load = async () => {
      try {
        const entityType = await api.syndication.remoteEntityTypes.item(entityTypeId);
        if (!cancelled) {
          setEntityTypeInfo({
            namespaceMachineName: entityType.namespaceMachineName,
            machineName: entityType.machineName,
          });
        }
      } catch {
        if (!cancelled) {
          setEntityTypeInfo(undefined);
        }
      }
    };

    void load();
    return () => {
      cancelled = true;
    };
  }, [api, entityTypeId]);

  const sharedEntityId: Uuid | ExternalServiceId | undefined = clone.targetRemoteUuid || clone.targetRemoteUniqueId;
  const pulledAt: RuntimeDate | undefined = clone.pulledAt;

  return (
    <tr key={clone.id}>
      <td>
        <SiteEntityName
          entityType={entityTypeInfo}
          sharedEntityId={sharedEntityId}
          pulledAt={pulledAt}
          isDeleted={isDeleted}
          skipResolve={isDeleted || !entityTypeInfo}
        />
      </td>
      <td>{pulledAt ? <FormatDate withTime>{pulledAt}</FormatDate> : <span className="text-muted">—</span>}</td>
      <td>
        <RemoteEntityStatusBadge status={clone.status} />
      </td>
      <td className="text-end">
        {!isDeleted && clone.viewUrl ? (
          <a href={clone.viewUrl} target="_blank" rel="noreferrer" className="text-decoration-none">
            View
          </a>
        ) : (
          <span className="text-muted">—</span>
        )}
      </td>
    </tr>
  );
}
